import React, { memo } from 'react'
import { string } from 'prop-types'

export const Article = memo(({ stroke = '#003B5C', height = '88px', width = '125px' }) => {
	return (
		<svg
			version="1.1"
			width={width}
			height={height}
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 68.6 58.2"
			style={{ enableBackground: 'new 0 0 68.6 58.2' }}
			xmlSpace="preserve"
		>
			<g>
				<path
					fill="#FFA06A"
					d="M61.7,8.8c-0.1-1.3-0.2-2.5-0.3-3.8c0-1,0.3-2.1-0.6-3h-8.3v10.3c0,0.3-1,0.5-2.1,0.5h11
					C61,11.4,61.8,10.1,61.7,8.8z"
				/>
			</g>
			<g>
				<path
					fill="#FFA06A"
					d="M67.7,40.1c-0.1-5.1-0.2-10.3-0.3-15.4c0-4.1,0.3-8.4-0.6-12.4h-8.3v41.9c0,1.2-1,2.1-2.1,2.1h11
					C67,50.9,67.8,45.3,67.7,40.1z"
				/>
			</g>
			<g>
				<g>
					<polyline
						fill="none"
						stroke={stroke}
						strokeWidth={3}
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeMiterlimit={10}
						points="1.5,52.9 1.5,1.5 60.7,1.5 60.7,12.4 		"
					/>
					<path
						fill="none"
						stroke={stroke}
						strokeWidth={3}
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeMiterlimit={10}
						d="M9.2,52.9V14.3c0-1,0.9-1.9,1.9-1.9h54.2c1,0,1.9,0.9,1.9,1.9v38.6"
					/>
					<path
						fill="none"
						stroke={stroke}
						strokeWidth={3}
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeMiterlimit={10}
						d="M1.5,52.9c0,2.1,1.7,3.8,3.8,3.8s3.8-1.7,3.8-3.8"
					/>
					<path
						fill="none"
						stroke={stroke}
						strokeWidth={3}
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeMiterlimit={10}
						d="M63.3,56.7c2.1,0,3.8-1.7,3.8-3.8"
					/>
					<line
						fill="none"
						stroke={stroke}
						strokeWidth={3}
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeMiterlimit={10}
						x1="5.3"
						y1="56.7"
						x2="63.3"
						y2="56.7"
					/>
				</g>
				<line
					fill="none"
					stroke={stroke}
					strokeWidth={3}
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeMiterlimit={10}
					x1="22.2"
					y1="24.7"
					x2="53.4"
					y2="24.7"
				/>
				<line
					fill="none"
					stroke={stroke}
					strokeWidth={3}
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeMiterlimit={10}
					x1="22.2"
					y1="34.6"
					x2="53.4"
					y2="34.6"
				/>
				<line
					fill="none"
					stroke={stroke}
					strokeWidth={3}
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeMiterlimit={10}
					x1="22.2"
					y1="44.9"
					x2="53.4"
					y2="44.9"
				/>
			</g>
		</svg>
	)
})

Article.propTypes = {
	stroke: string,
	height: string,
	width: string,
}
